import React from 'react';
import './Home.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';


const Home = () => {

  return (
    <>
      <Container className="text-center">
        <Row>
          <Col md={12} lg={12}>
            <Fade bottom duration={3000}>
              <div className="home">
                <div className="content-center">
                  <h1 className="custom-h1">
                    <Zoom
                      delay={1000}
                      duration={3000}
                      left cascade>
                      <div
                        style={{ display: 'inline-block' }}>
                        Jannatun Na
                        </div>
                    </Zoom>
                    <Zoom
                      delay={1000}
                      duration={3000}
                      right
                      cascade>
                      <div style={{ display: 'inline-block' }}>
                        her Reya
                        </div>
                    </Zoom>
                  </h1>

                  <p>
                    A passionate Front-end Developer with a keen eye for  creating professional stunning websites using modern web technologies.
              </p>
                  <a href="https://drive.google.com/uc?export=download&id=1R6K5FGMt5UszCWfFnxJ3gSxAOL4nguTW"
                    target="_blank"
                    rel="noreferrer"
                    download>
                    <Button
                      className="resume-btn" variant="outline-warning">
                      Download Resume
                    </Button>
                  </a>

                </div>
              </div>
            </Fade>

          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;